/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createJobResponseFromDiscriminatorValue, serializeCreateVideoTrimJobRequest, serializeJobResponse, type CreateVideoTrimJobRequest, type HttpValidationProblemDetails, type IError, type JobResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit/trim
 */
export interface TrimRequestBuilder extends BaseRequestBuilder<TrimRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CreateVideoTrimJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateVideoTrimJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TrimRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit/trim";
/**
 * Metadata for all the requests in the request builder.
 */
export const TrimRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: TrimRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateVideoTrimJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
